module.exports = {
    NOTHING: "nothing",
    DISCOVER_SYSTEMS: "discover-systems",
    LEARN_SHIP_LANGUAGE: "learn-ship-language",
    GENERATE_POWER: "generate-power",
    REPAIR_PER_TICK: 0.01,
}



// WEBPACK FOOTER //
// ./src/actions/user-actions-constants.js